import { PINNED_ORDER_MAX } from './sidebarDnd.js';
import { prefs } from './storage.js';

/**
 * Manual order of pinned chats, remembered per section on this device.
 * Shared between every sidebar list so a drop in one list is reflected in the
 * pinned list immediately.
 */

type Listener = (section: string) => void;
const listeners = new Set<Listener>();

export function pinnedOrderKey(section: string): string {
  return `pinnedOrder.${section}`;
}

export function loadPinnedOrder(section: string): string[] {
  try {
    const stored = prefs.get(pinnedOrderKey(section));
    const parsed: unknown = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/** Write the order without telling subscribers (used to mirror a list's own state). */
export function persistPinnedOrder(section: string, ids: string[]): void {
  prefs.set(pinnedOrderKey(section), JSON.stringify(ids.slice(0, PINNED_ORDER_MAX)));
}

/** Write a new order and let every sidebar list pick it up. */
export function savePinnedOrder(section: string, ids: string[]): void {
  persistPinnedOrder(section, ids);
  for (const listener of listeners) listener(section);
}

/** Notified after `savePinnedOrder`; returns an unsubscribe function. */
export function subscribePinnedOrder(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
